import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/model/auth';
import { Ndg, NdgRequest } from 'src/app/model/ndg';
import { SurveyForList } from 'src/app/model/survey-response';
import { AuthService } from 'src/app/service/auth.service';
import { MessageService } from 'src/app/service/message.service';
import { NdgService } from 'src/app/service/ndg.service';
import { ExitDialogComponent } from './exit-dialog/exit-dialog.component';

@Component({
  templateUrl: './external.component.html',
  styleUrls: ['./external.component.scss']
})
export class ExternalComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  
  ndg!: Ndg;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private ndgService: NdgService,
    private messageService: MessageService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscription = this.route.queryParams.subscribe({
      next: (params: Params) => {
        const token = params['token'];
        const clientId = params['clientId'];

        // Authenticate with param token
        this.authService.authenticateExternal(token).subscribe({
          next: (auth: Auth) => {
            // Authentication successful
            this.retrieveNdg(clientId, auth.name);
          },
          error: () => {
            // Authentication failed
            this.doManageError('survey.external.authentication-failed');
            this.router.navigate(['/']);
          }
        });
      }
    });
  }

  private retrieveNdg(clientId: string, ndgName: string): void {
    this.ndgService.getNdgByClientId(clientId).subscribe({
      next: (ndg: Ndg) => {
        this.ndg = ndg;
        this.messageService.success('survey.external.authentication-success', {name: ndgName});
      },
      error: () => {
        this.doManageError('survey.external.client-id-not-found', {clientId: clientId});
      }
    });
  }

  private doManageError(message: string, parameters: Object = {}): void {
    this.messageService.error(message, parameters);
    window.parent.postMessage(null, '*');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSurveyCompleted(surveyInfo: SurveyForList): void {
    window.parent.postMessage(surveyInfo.surveyId, '*');
  }

  doOpenExitDialog() {
    const dialogRef = this.dialog.open(ExitDialogComponent, {
      width: '500px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: (result: boolean) => {
        if(result) {
          window.parent.postMessage('', '*');
        }
      }
    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeHandler() {
    this.doOpenExitDialog();
  }
}
